import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=43e9bc50&scoped=true&"
import script from "./DeleteAccount.vue?vue&type=script&lang=js&"
export * from "./DeleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=43e9bc50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e9bc50",
  null
  
)

export default component.exports